import * as React from 'react';

import { createCtx } from '@pletly/ui';
import { User, useUser } from '@pletly/feature-auth';

const [useLoggedUser, LoggedUserDataProvider] = createCtx<User>();

const LoggedUserProvider = ({ children }: { children?: React.ReactNode }) => {
	const user = useUser();

	if (!user) {
		throw new Error('Must be used inside AuthenticatedApp');
	}

	return <LoggedUserDataProvider value={user}>{children}</LoggedUserDataProvider>;
};

export { LoggedUserProvider, useLoggedUser };
